import { type FetchLike, MedplumClient } from "@medplum/core";
import { createRetryFetch } from "@/lib/medplum/retry";
import { ServerSideStorage } from "@/lib/medplum/storage";

export interface MedplumAdminClientOptions {
  /**
   * Replaces the default retry fetch. Lets a caller wrap every request without restating the
   * admin credential wiring - e.g. the v2 provisioning script's on-behalf-of verification probe.
   */
  fetch?: FetchLike;
}

export function createMedplumAdminClient(options: MedplumAdminClientOptions = {}): MedplumClient {
  if (!process.env.MEDPLUM_ADMIN_CLIENT_ID || !process.env.MEDPLUM_ADMIN_CLIENT_SECRET) {
    throw new Error(
      "Missing MEDPLUM_ADMIN_CLIENT_ID or MEDPLUM_ADMIN_CLIENT_SECRET environment variables",
    );
  }
  return new MedplumClient({
    baseUrl: process.env.MEDPLUM_BASE_URL || "https://api.medplum.com/",
    clientId: process.env.MEDPLUM_ADMIN_CLIENT_ID,
    clientSecret: process.env.MEDPLUM_ADMIN_CLIENT_SECRET,
    fetch: options.fetch ?? createRetryFetch({ label: "admin" }),

    // Disable caching.
    cacheTime: 0,
    storage: new ServerSideStorage(),
  });
}
